<div class="tracking-viewport bg-light min-vh-100 py-5">
  <div class="container">
    
    <!-- Logo y Título -->
    <div class="text-center mb-5">
      <img src="assets/logo.png" alt="Logo" class="mb-3" style="max-height: 80px;">
      <h1 class="fw-bold text-dark">Portal de Seguimiento</h1>
      <p class="text-muted">Consulta el avance de tu servicio en ServiTrack</p>
    </div>

    <!-- Pantalla de Carga -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-3">Buscando tu orden...</p>
    </div>

    <!-- Error / No Encontrado -->
    <div *ngIf="!isLoading && error" class="card border-0 shadow-sm rounded-20 p-5 text-center mx-auto" style="max-width: 500px;">
      <i class="bi bi-search display-1 text-muted opacity-25"></i>
      <h3 class="mt-4 fw-bold">Orden no encontrada</h3>
      <p class="text-muted">No pudimos encontrar una orden con el número <strong>{{ caseNumber }}</strong>. Por favor, verifica el ticket o contacta al taller.</p>
      <button class="btn btn-primary rounded-pill px-4 mt-3" onclick="window.location.reload()">Reintentar</button>
    </div>

    <!-- Contenido de la Orden -->
    <div *ngIf="!isLoading && !error && (work$ | async) as work" class="animate-fade-in">
      
      <!-- Card Principal de Estado -->
      <div class="card border-0 shadow-lg rounded-24 mb-4 overflow-hidden">
        <div class="card-header bg-dark text-white p-4 border-0 d-flex justify-content-between align-items-center">
          <div>
            <span class="small text-uppercase opacity-75 d-block">Número de Orden</span>
            <h2 class="mb-0 fw-bold">{{ work.caseNumber }}</h2>
          </div>
          <div class="text-end">
             <span class="badge bg-primary px-3 py-2 rounded-pill">{{ work.serviceType }}</span>
          </div>
        </div>

        <div class="card-body p-4 p-md-5">
          
          <!-- Stepper / Progress Bar -->
          <div class="tracking-stepper mb-5">
            <div class="stepper-line"></div>
            <div class="steps-container">
              <div *ngFor="let step of steps" class="step" [ngClass]="getStepClass(step.status, work.currentStatus)">
                <div class="step-icon shadow-sm">
                  <i class="bi" [ngClass]="step.icon"></i>
                </div>
                <span class="step-label mt-2">{{ step.label }}</span>
              </div>
            </div>
          </div>

          <!-- Mensaje de Estado Actual -->
          <div class="status-alert p-4 rounded-20 text-center mb-4" 
               [ngClass]="{
                 'bg-primary-subtle text-primary border-primary': work.currentStatus === 'Received' || work.currentStatus === 'In Progress',
                 'bg-success-subtle text-success border-success': work.currentStatus === 'Ready' || work.currentStatus === 'Completed',
                 'bg-warning-subtle text-warning border-warning': work.currentStatus === 'Awaiting Parts'
               }">
            <h4 class="fw-bold mb-2">Estado: {{ getSpanishStatus(work.currentStatus) }}</h4>
            <p class="mb-0 lead">{{ getStatusMessage(work.currentStatus) }}</p>
          </div>

          <!-- Detalles de la Bicicleta -->
          <div class="row g-4 mt-2">
            
            <div class="col-md">
              <div class="info-box p-3 bg-light rounded-16 h-100 border">
                <small class="text-muted text-uppercase fw-bold">Bicicleta</small>
                <h5 class="mb-0 fw-bold">{{ work.bikeDescription }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card de Historial Detallado (Opcional para cliente) -->
      <div class="card border-0 shadow-sm rounded-24 mt-4" *ngIf="status$ | async as statusDoc">
        <div class="card-header bg-white border-0 pt-4 px-4">
          <h5 class="fw-bold mb-0">Línea de Tiempo del Servicio</h5>
        </div>
        <div class="card-body p-4">
          <div class="timeline">
            <div *ngFor="let log of statusDoc.history; let last = last" class="timeline-item">
              <div class="timeline-dot bg-primary shadow-sm"></div>
              <div class="timeline-content">
                <div class="d-flex justify-content-between">
                  <span class="fw-bold text-dark">{{ getSpanishStatus(log.status) }}</span>
                  <small class="text-muted">{{ log.timestamp?.toDate() | date:'shortTime' }} - {{ log.timestamp?.toDate() | date:'dd MMM' }}</small>
                </div>
                <p class="text-muted small mb-0 mt-1" *ngIf="log.notes">{{ log.notes }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Footer del Portal -->
    <div class="text-center mt-5">
      <p class="text-muted small">Powered by <strong>ServiTrack</strong> &copy; 2026</p>
    </div>

  </div>
</div>